import { IVideosContext, IFilterValues } from './videosContext';

export enum VideosActionTypes {
	SET_VIDEOS = 'SET_VIDEOS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_STUDIO = 'SET_STUDIO',
	SET_CATEGORY = 'SET_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	TOGGLE_UNASSIGNED_VIDEOS = 'TOGGLE_UNASSIGNED_VIDEOS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_FULL_INFO = 'SET_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetVideos {
	type: VideosActionTypes.SET_VIDEOS;
	payload: {
		videos: IVideosContext['videos'];
		typeOfModalWindow: IVideosContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: VideosActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IVideosContext['searchString'];
	};
}

interface ISetStudio {
	type: VideosActionTypes.SET_STUDIO;
	payload: {
		selectedStudio: IVideosContext['selectedStudio'];
	};
}

interface ISetCategory {
	type: VideosActionTypes.SET_CATEGORY;
	payload: {
		selectedCategory: IVideosContext['selectedCategory'];
	};
}

interface IResetSelectedControls {
	type: VideosActionTypes.RESET_SELECTED_CONTROLS;
}

interface IToggleUnassignedVideos {
	type: VideosActionTypes.TOGGLE_UNASSIGNED_VIDEOS;
}

interface ISetSortBy {
	type: VideosActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IVideosContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: VideosActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IVideosContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: VideosActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IVideosContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: VideosActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IVideosContext['IDForDeletion'];
		typeOfModalWindow: IVideosContext['typeOfModalWindow'];
	};
}

interface ISetIDForFullInfo {
	type: VideosActionTypes.SET_ID_FOR_FULL_INFO;
	payload: {
		IDForFullInfo: IVideosContext['IDForFullInfo'];
	};
}

interface IChangeTypeOfModalWindow {
	type: VideosActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IVideosContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: VideosActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TVideosAction =
	| ISetVideos
	| IChangeSearchString
	| ISetStudio
	| ISetCategory
	| IResetSelectedControls
	| IToggleUnassignedVideos
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForFullInfo
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
